import "./tabs.scss"; // Import the SCSS file for styling the Tabs component

interface ITabs {
  value?: string; // The current active tab value (optional)
  handleChange: (e: string) => void; // Function to handle tab change
  options: any[]; // Array of tab options, each should have `value` and `label` properties
}

/**
 * Tabs component displays a set of tabs and allows the user to switch between them.
 *
 * @param {ITabs} props - The properties object for the Tabs component.
 * @param {string} [props.value] - The current active tab value.
 * @param {(e: string) => void} props.handleChange - Function to handle tab change when a tab is clicked.
 * @param {any[]} props.options - Array of tab options, where each option has a `value` and `label`.
 *
 * @returns {JSX.Element} The rendered Tabs component.
 */
export const Tabs = ({ value, handleChange, options }: ITabs) => {
  return (
    <div className="tabs-wrapper">
      <div className="tabs-wrapper__login-options">
        {/* Map through the options and render each tab */}
        {options?.map?.((el: any, index: number) => (
          <div
            className={`tabs-wrapper__login-options__item ${
              value === el.value ? "tabs-wrapper__login-options--active" : "" // Apply active class if this tab is selected
            }`}
            key={index.toString() + el.label} // Unique key for each tab
            onClick={() => handleChange(el.value)} // Handle tab click
          >
            {el.label} {/* Display the tab label */}
          </div>
        ))}
      </div>
    </div>
  );
};
